import { fetchService } from 'actions/services'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { useEffect } from 'react'

export const useService = (serviceId: number | undefined) => {
    const dispatch = useAppDispatch()
    const service = useAppSelector((state) =>
        serviceId ? state.services.entities.services?.[serviceId] : undefined,
    )
    const isLoading = useAppSelector((state) => state.services.isFetching)

    useEffect(() => {
        if (serviceId) {
            dispatch(fetchService(serviceId))
        }
    }, [dispatch, serviceId])

    return { service, isLoading }
}
